import { render, staticRenderFns } from "./NavigationTreeItem.vue?vue&type=template&id=c10ba68a"
import script from "./NavigationTreeItem.vue?vue&type=script&lang=js"
export * from "./NavigationTreeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports